export const MCLUSTERTable = [{
  testSystem:'Si',
  atomicNum:'5120',
  electronicNum:'20480',
  truncationCan:'340',
  turns:'FHI',
  time:'3小时'
},
  {
    testSystem:'Si',
    atomicNum:'4096',
    electronicNum:'16384',
    truncationCan:'340',
    turns:'FHI',
    time:'1小时'
  },
  {
    testSystem:'Si',
    atomicNum:'4096',
    electronicNum:'16384',
    truncationCan:'680',
    turns:'SG15',
    time:'3小时'
  },
  {
    testSystem:'Si',
    atomicNum:'3072',
    electronicNum:'12288',
    truncationCan:'340',
    turns:'FHI',
    time:'22分钟'
  },
  {
    testSystem:'Si',
    atomicNum:'3072',
    electronicNum:'12288',
    truncationCan:'680',
    turns:'SG15',
    time:'42分钟'
  },
  {
    testSystem:'Si',
    atomicNum:'1728',
    electronicNum:'6912',
    truncationCan:'340',
    turns:'FHI',
    time:'7分钟'
  },
  {
    testSystem:'Si',
    atomicNum:'1728',
    electronicNum:'6912',
    truncationCan:'680',
    turns:'SG15',
    time:'16分钟'
  },
  {
    testSystem:'H2O',
    atomicNum:'3000',
    electronicNum:'8000',
    truncationCan:'340',
    turns:'FHI',
    time:'150秒一步MD'
  },
  {
    testSystem:'H2O',
    atomicNum:'3000',
    electronicNum:'8000',
    truncationCan:'480',
    turns:'FHI',
    time:'840秒一步MD'
  },]